import { defineMeta } from '../../../../define';

export default defineMeta({
  id: 'js-values-template-literals',
  slug: 'template-literals',
  title: 'Build a price label',
  type: 'code',
  estSeconds: 300,
  contentVersion: 1,
});
